export default "__VITE_ASSET__8RRHI7bY__"